import React from 'react'

const AlignCenterIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M7 15V17H17V15H7ZM3 21H21V19H3V21ZM3 13H21V11H3V13ZM7 7V9H17V9H7ZM3 3V5H21V3H3Z"
            fill={color}
        />
    </svg>
)

export default AlignCenterIcon
